import { render, staticRenderFns } from "./CoworkersStatusCalendar.vue?vue&type=template&id=1511ff65&"
import script from "./CoworkersStatusCalendar.vue?vue&type=script&lang=js&"
export * from "./CoworkersStatusCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CoworkersStatusCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports